import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";
import ConfigService from "./services/ConfigService";
import ElectronService from "./services/ElectronService";
import EventsService from "./services/EventsService";
import Telemetry from "@poriyaalar/telemetry";

// scroll bar
import "simplebar/src/simplebar.css";

import { get, isEmpty } from "lodash";
import { HelmetProvider } from "react-helmet-async";
import { isValidUUID } from "./utils/isValidUUID.js";
import LoadingScreen from "./components/LoadingScreen.jsx";
import { ErrorConstants } from "./constants/ErrorConstants.js";

function RootLoader({ text = "Loading..." }) {
  return <LoadingScreen />;
}

const root = document.getElementById("root");

const appRoot = ReactDOM.createRoot(root);

appRoot.render(
  <BrowserRouter>
    <RootLoader />
  </BrowserRouter>
);

if (import.meta.env.VITE_APP_ENV === "production") {
  const TelemetryService = new Telemetry({
    sentry: {
      dsn: "https://d74563c4b3d3862f29e8f45a616c6729@o4507809692712960.ingest.de.sentry.io/4508883718242384",
      environment: import.meta.env.VITE_APP_ENV,
      tracePropagationTargets: [/^https:\/\/public\.positeasy\.in\//],
      tracesSampleRate: 0,
    },
  });
  window.telemetry = TelemetryService;
}
const PATH_ARRAY = window.location.pathname.split("/");
if (window.mainAPI) {
  console.log = (args, data) => {
    window.mainAPI.log("log", { args, data });
  };
}

function validateMerchantId(merchantId, storeId) {
  return new Promise((resolve, reject) => {
    if (!merchantId || !storeId) {
      reject(new Error(ErrorConstants.MERCHANT_OR_STORE_ID_MISSING));
      return;
    }

    fetch(
      `${
        import.meta.env.VITE_REMOTE_URL
      }/api/v1/POS/merchant/on-table/otherDetails?merchantId=${merchantId}&storeId=${storeId}`,
    )
      .then((res) => {
        if (!res.ok) throw new Error(ErrorConstants.API_FAILED);
        return res.json();
      })
      .then((data) => {
        if (!isEmpty(data)) {
          sessionStorage.setItem("storeDetails", JSON.stringify(data));
          resolve(true);
        } else {
          reject(new Error(ErrorConstants.EMPTY_RESPONSE));
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}


function hideLoader() {}

function showLoaderError(text) {
  appRoot.render(
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {text}
    </div>,
  );
}

function bootApp() {
  const localMerchantDetails = sessionStorage.getItem("merchantDetails");
  console.log(PATH_ARRAY, "APAARH ARRAYY");
  const localPaymentId = JSON.parse(
    sessionStorage.getItem("trackOrder") || "{}",
  );
  const isTrackingPage = get(localPaymentId, "paymentId", false);

  const isTable = isValidUUID(PATH_ARRAY[3]);
  const subPath = isTrackingPage
    ? `/${isTrackingPage}`
    : isEmpty(localMerchantDetails)
      ? isTable
        ? `/${PATH_ARRAY[1]}/${PATH_ARRAY[2]}/${PATH_ARRAY[3]}`
        : `/${PATH_ARRAY[1]}/${PATH_ARRAY[2]}`
      : isTable
        ? `/${get(JSON.parse(localMerchantDetails), "merchantId")}/${get(
            JSON.parse(localMerchantDetails),
            "storeId",
          )}/${get(JSON.parse(localMerchantDetails), "tableId")}`
        : `/${get(JSON.parse(localMerchantDetails), "merchantId")}/${get(
            JSON.parse(localMerchantDetails),
            "storeId",
          )}`;
  console.log(subPath, "SUSUUB");
  EventsService.boot(() => {
    ConfigService.boot(() => {
      hideLoader();
      appRoot.render(
        <React.StrictMode>
          <HelmetProvider>
            <BrowserRouter basename={subPath}>
              <App />
            </BrowserRouter>
          </HelmetProvider>
        </React.StrictMode>,
      );
    });
  });
  window.ElectronService = ElectronService;
}
function bootAppForRajalakshmi(merchantId, storeId, tabldId = false) {
  const subPath = tabldId
    ? `/${merchantId}/${storeId}/${tabldId}`
    : `/${merchantId}/${storeId}`;

  EventsService.boot(() => {
    ConfigService.boot(() => {
      hideLoader();
      appRoot.render(
        <React.StrictMode>
          <HelmetProvider>
            <BrowserRouter basename={subPath}>
              <App />
            </BrowserRouter>
          </HelmetProvider>
        </React.StrictMode>,
      );
    });
  });
  window.ElectronService = ElectronService;
}

function renderErrorPage() {
  showLoaderError("Invalid Merchant ID");
}
function renderTransactionError() {
  showLoaderError("Invalid Transaction");
}
// ----------------------------------------------------------------------

// verification of merchantId and storeId

const localMerchantDetails = sessionStorage.getItem("merchantDetails");
const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("tableId");
console.log(window.location.pathname, "PARRRAMS");
console.log(PATH_ARRAY, "PAATHH RARRRA");
if (window.location.pathname === "/track/order") {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const urlParamsData = {};
  for (const [key, value] of urlParams.entries()) {
    urlParamsData[key] = value;
  }
  window.urlParamsData = urlParamsData;
  
  const paymentId = get(urlParamsData, "paymentId");
  console.log("iraannn");
  if (paymentId) {
    sessionStorage.setItem("trackOrder", JSON.stringify({ paymentId }));
    window.location.href = `/${paymentId}/track/order`;
    bootApp();
  } else {
    renderTransactionError();
  }
} else if (window.location.pathname.includes("/track/order")) {
  const paymentId = PATH_ARRAY[1];
  if (paymentId) {
    sessionStorage.setItem("trackOrder", JSON.stringify({ paymentId }));
    bootApp();
  } else {
    renderTransactionError();
  }
} else if (window.location.pathname === "/") {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let urlParamsData = {};
  for (const [key, value] of urlParams.entries()) {
    urlParamsData[key] = value;
  }
  const currentUrl = window.location.href;
  window.urlParamsData = urlParamsData;
  console.log(currentUrl, "CCCCCC");

  if (currentUrl === "https://rajalakshmiengg.positeasy.in/") {
    console.log("urlParamsData", currentUrl);
    const emptyurl = isEmpty(urlParamsData);
    const merchantId = "9648af36-db50-4e16-89fc-4741e62ae448";
    const storeId = "Store1s";
    const type = get(urlParamsData, "type");
    const tableId = get(urlParamsData, "tableId");
    const menuDisplay = get(
      emptyurl ? JSON.parse(localMerchantDetails) : urlParamsData,
      "menuDisplay",
    );
    validateMerchantId(merchantId, storeId)
      .then((isValid) => {
        console.log(isValid, "ISSVALIDD");
        if (isValid) {
          sessionStorage.setItem(
            "merchantDetails",
            JSON.stringify({ merchantId, storeId, type, tableId, menuDisplay }),
          );
          if (tableId) {
            bootAppForRajalakshmi(merchantId, storeId, tableId);
          } else {
            console.log("iraan");
            bootAppForRajalakshmi(merchantId, storeId);
          }
          window.location.href = tableId
            ? `/${merchantId}/${storeId}/${tableId}`
            : `/${merchantId}/${storeId}`;
        } else {
          renderErrorPage();
        }
      })
      .catch((err) => {
        console.log("error", err);
        renderErrorPage();
      });
  } else if (currentUrl === "https://app.kodo.co.in/") {
    console.log("urlParamsData", currentUrl);
    const emptyurl = isEmpty(urlParamsData);
    const merchantId = "21fc782e-ffe4-4a9f-9f49-32701a5aef5a";
    const storeId = "Store1s";
    const type = get(urlParamsData, "type");
    const tableId = get(urlParamsData, "tableId");
    const menuDisplay = get(
      emptyurl ? JSON.parse(localMerchantDetails) : urlParamsData,
      "menuDisplay",
    );
    validateMerchantId(merchantId, storeId)
      .then((isValid) => {
        if (isValid) {
          sessionStorage.setItem(
            "merchantDetails",
            JSON.stringify({ merchantId, storeId, type, tableId, menuDisplay }),
          );
          if (tableId) {
            bootAppForRajalakshmi(merchantId, storeId, tableId);
          } else {
            console.log("iraan");
            bootAppForRajalakshmi(merchantId, storeId);
          }
          window.location.href = tableId
            ? `/${merchantId}/${storeId}/${tableId}`
            : `/${merchantId}/${storeId}`;
        } else {
          renderErrorPage();
        }
      })
      .catch((err) => {
        console.log("error", err);
        renderErrorPage();
      });
  } else {
    const emptyurl = isEmpty(urlParamsData);
    const merchantId = get(
      emptyurl ? JSON.parse(localMerchantDetails) : urlParamsData,
      "merchantId",
    );
    const storeId =
      get(
        emptyurl ? JSON.parse(localMerchantDetails) : urlParamsData,
        "StoreId",
      ) ??
      get(
        emptyurl ? JSON.parse(localMerchantDetails) : urlParamsData,
        "storeId",
      );
    const menuDisplay = get(
      emptyurl ? JSON.parse(localMerchantDetails) : urlParamsData,
      "menuDisplay",
    );

    const type = get(urlParamsData, "type");
    const tableId = get(urlParamsData, "tableId");
    validateMerchantId(merchantId, storeId)
      .then((isValid) => {
        if (isValid) {
          sessionStorage.setItem(
            "merchantDetails",
            JSON.stringify({ merchantId, storeId, type, tableId, menuDisplay }),
          );
          bootApp();
          console.log(tableId, type, "TAABLE");
          window.location.href = tableId
            ? `/${merchantId}/${storeId}/${tableId}`
            : `/${merchantId}/${storeId}`;
        } else {
          renderErrorPage();
        }
      })
      .catch((err) => {
        renderErrorPage();
      });
  }
} else if (
  window.location.pathname !== "/" &&
  (!isEmpty(localMerchantDetails) ||
    !isEmpty(PATH_ARRAY[1]) ||
    !isEmpty(PATH_ARRAY[2]))
) {
  const merchantId = PATH_ARRAY[1];
  const storeId = PATH_ARRAY[2];
  const savedMerchantDetails = JSON.parse(localMerchantDetails || "{}");
  const isSameStore =
    savedMerchantDetails.merchantId === merchantId &&
    savedMerchantDetails.storeId === storeId;

  // Direct links must load the current subscription before App selects a router.
  validateMerchantId(merchantId, storeId)
    .then((isValid) => {
      if (!isValid) {
        renderErrorPage();
        return;
      }
      const { tableId: savedTableId, ...savedStoreDetails } =
        savedMerchantDetails;
      sessionStorage.setItem(
        "merchantDetails",
        JSON.stringify({
          ...(isSameStore ? savedStoreDetails : {}),
          merchantId,
          storeId,
          ...(isValidUUID(PATH_ARRAY[3]) && { tableId: PATH_ARRAY[3] }),
        }),
      );
      bootApp();
    })
    .catch(() => {
      renderErrorPage();
    });
} else {
  renderErrorPage();
}
